var map = {
	"./check.svg": "a7c0",
	"./close.svg": "864a",
	"./company.svg": "5cd5",
	"./contact.svg": "42b2",
	"./dang.svg": "f4c5",
	"./dashboard.svg": "7154",
	"./default-menu.svg": "dbb0",
	"./example.svg": "b6f9",
	"./eye-open.svg": "74a2",
	"./eye.svg": "57fa",
	"./form.svg": "4576",
	"./go-back.svg": "a730",
	"./gonggao.svg": "04cf",
	"./index.svg": "a8af",
	"./lianxi.svg": "fd9f",
	"./link.svg": "5fda",
	"./logo.svg": "d9b6",
	"./logout.svg": "a14d",
	"./look.svg": "b69e",
	"./manage.svg": "0410",
	"./moresrv.svg": "07e2",
	"./nested.svg": "91be",
	"./news.svg": "2d72",
	"./notice.svg": "ee69",
	"./party.svg": "1e48",
	"./password.svg": "198d",
	"./qiyewenhua.svg": "6838",
	"./recruit.svg": "0c93",
	"./safe.svg": "e3a0",
	"./son.svg": "39c7",
	"./sys-change.svg": "44d6",
	"./table.svg": "dc78",
	"./tree.svg": "0e8f",
	"./upload.svg": "068c",
	"./user.svg": "d88a",
	"./wenhua.svg": "3065",
	"./wsyyt.svg": "dd1b",
	"./xinwen.svg": "4aa8",
	"./zhaopin.svg": "1c8f",
	"./zhengce.svg": "1e7e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";